'use strict';

/**
 * @ngdoc directive
 * @name 360StoreAngularApp.directive:stReportsMenu
 * @description
 * # stReportsMenu
 */
angular.module('360StoreAngularApp')
	.directive('stReportsMenu', function () {
		return {
			template: `
      <ul>
		<li><a href="/reports/dynamic-report?report=EmailReport">Emails Sent</a></li>
		<li><a href="/reports/dynamic-report?report=PromoReport">Promo Usage</a></li>
		<li><a href="/reports/dynamic-report?report=RecentlyLapsed">Recently Lapsed</a></li>
		<li><a href="/reports/dynamic-report?report=SalesReport">Orders (detailed search capabilities)</a></li>
		<li><a href="/reports/dynamic-report?report=ExpiredMaintenanceFollowupReport">Expired Maintenance Followup</a></li>
		<li><a href="/reports/dynamic-report?report=SalesSummaryReport">Sales Summary (30, 60, 90. 365)</a></li>
		<li><a href="/reports/dynamic-report?report=SalesWeeklyReport">Sales Weekly (revenue week-by-week)</a></li>
		<li><a href="/reports/dynamic-report?report=ProductUsageReport">Product Usage (licenses checking in with LicenseCheck)</a></li>
	</ul>
`,
			restrict: 'E',
		};
	});
